import React from 'react';

export const LeaderboradContext = React.createContext();

export function useLeaderborad() {
    return React.useContext(LeaderboradContext);
}